// ============================================================
// STYLES 4 KIDZ — BUILDING CROWNS 4 THE FUTURE GALA
// SHINE NATIONWIDE CAMPAIGN 2026
// CENTRAL EVENT CONFIG — the S4K team edits EVERYTHING here:
// dates, times, venue, ticket prices, URLs, fundraising totals,
// sponsorship tiers, after-party details, socials, contacts.
// ============================================================

const G = "/assets/gala"; // official 2025 gala photography — Jamilla Yipp Photography

export const EVENT_CONFIG = {
  org: {
    name: "Styles 4 Kidz",
    website: "https://styles4kidz.org/",
    email: "info@styles4kidz.org",
    phone: "708.434.5680",
    address: "235 Harrison Street, Oak Park, IL 60304",
    mission:
      "Styles 4 Kidz strengthens relationships in biracial, transracial adoptive, and foster families through high-quality, compassionate hair-care education and services for kids with textured hair.",
    socials: {
      instagram: "http://instagram.com/styles4kidznfp/",
      facebook: "http://facebook.com/styles4kidz",
      twitter: "https://twitter.com/styles4kidznfp",
      youtube: "https://www.youtube.com/c/Styles4KidzNFP",
    },
  },

  event: {
    title: "Building Crowns 4 The Future",
    titleAccent: "Gala",
    campaign: "Shine Nationwide Campaign 2026",
    dateISO: "2026-11-07T19:00:00-06:00", // EDITABLE — drives the countdown (gala start)
    dateDisplay: "Saturday, November 7, 2026",
    vipTime: "6:00 PM – 7:00 PM",
    galaTime: "7:00 PM – 10:00 PM",
    venue: "Nineteenth Century Club",
    venueAddress: "178 Forest Avenue, Oak Park, IL 60301",
    city: "Oak Park, Illinois",
  },

  urls: {
    buyTickets:
      "https://secure.givelively.org/event/styles-for-kidz-nfp/styles-4-kidz-building-crowns-for-the-future-fall-gala",
    donate: "https://styles4kidz.org/give",
    donateMonthly:
      "https://secure.givelively.org/donate/styles-for-kidz-nfp/care-4-crowns-monthly-giving-campaign",
    afterPartyTickets: "", // EDITABLE — add official after-party ticket URL when confirmed
    sponsorshipDeck: "", // EDITABLE — add sponsorship deck PDF URL when ready
    photoCredit: "https://jamillayippphotography.pixieset.com/stylzgala2025/",
  },

  fundraising: {
    goal: 2000000,
    raised: 0, // EDITABLE — current amount raised
    donors: 0, // EDITABLE — current donor count
    childrenImpacted: 0, // EDITABLE — children impacted to date
    milestones: [
      { value: 0, label: "$0" },
      { value: 500000, label: "$500K" },
      { value: 1000000, label: "$1M" },
      { value: 1500000, label: "$1.5M" },
      { value: 2000000, label: "$2M" },
    ],
  },

  afterParty: {
    venue: "MAKS in La Grange",
    dateDisplay: "November 7, 2026",
    startTime: "10:00 PM", // CONFIRMED — official start time
    startTimeFlag: null, // set a string to show a "to be confirmed" flag next to the time
    endTime: "3:00 AM",
    goal: 250000,
    raised: 0, // EDITABLE — after-party amount raised
    packagePrice: null, // S4K confirmed: no Gala + After Party bundle — after party is ticketed separately
  },

  // price: null renders as "TBA" — set a number when confirmed.
  tickets: [
    { id: "early-bird", name: "Early Bird", price: 125, note: "Gala admission · available until October 1", tag: "Save $25" },
    { id: "regular", name: "Gala Ticket", price: 150, note: "Gala admission · after October 1", tag: null },
    { id: "vip", name: "VIP Experience", price: null, note: "VIP Reception 6–7 PM + gala admission · price TBA", tag: "Limited" },
    { id: "table", name: "Table", price: null, note: "Seat your full party together · price TBA", tag: null },
    { id: "corporate-table", name: "Corporate Table", price: null, note: "Bring your company to the table · price TBA", tag: null },
    { id: "sponsorship", name: "Sponsorship", price: 1250, note: "Official packages from Bronze to Partner · $1,250 – $25,000", tag: "Crown Partner", scrollTo: "sponsor" },
  ],

  // OFFICIAL sponsorship levels published on the S4K GiveLively event page.
  sponsorshipTiers: [
    { id: "bronze", name: "Bronze Sponsorship", amount: 1250, note: "Official package — benefits listed on the event page" },
    { id: "silver", name: "Silver Sponsorship", amount: 2750, note: "Official package — benefits listed on the event page" },
    { id: "gold", name: "Gold Sponsorship", amount: 7500, note: "Official package — benefits listed on the event page" },
    { id: "presenting", name: "Presenting Sponsor", amount: 15000, note: "Official package — benefits listed on the event page" },
    { id: "partner", name: "Partner Sponsor", amount: 25000, note: "Official package — benefits listed on the event page" },
  ],

  donationAmounts: [25, 50, 100, 250, 500, 1000, 2500, 5000, 10000, 25000, 50000, 100000],

  // Verified current figures from styles4kidz.org
  impact: [
    { value: 5225, suffix: "+", label: "Children Served" },
    { value: 455, suffix: "", label: "Families Supported" },
    { value: 210, suffix: "", label: "Educational Workshops" },
    { value: 4071, suffix: "", label: "Hair Care Services" },
  ],

  programs: [
    "Hair Care Workshops",
    "Parent Advocacy Groups",
    "Online Training Platform",
    "Salon Services",
    "Workshops for Teens",
    "Group Home Services",
    "Sponsor-a-Kid",
  ],

  // Editable gala-evening program placeholders — no performers invented.
  galaProgram: [
    { time: "6:00 PM", title: "VIP Reception", detail: "Red carpet arrivals · cocktails · photo moments", vip: true },
    { time: "7:00 PM", title: "The Gala Begins", detail: "Welcome · dinner service · opening moments" },
    { time: "7:00 – 10:00 PM", title: "Dinner, Program & Celebration", detail: "Impact stories · live entertainment [TBA] · speakers [TBA] · awards · fundraising moment · dancing · special surprises" },
  ],

  afterPartyMoments: ["DJ [TBA]", "Dancing", "Food", "Drinks", "Photo Moments", "VIP", "Surprise Experiences"],

  hashtags: ["#BuildingCrowns4TheFuture", "#Styles4Kidz", "#AdultPromForAPurpose"],

  dressCode: [
    "Black Tie",
    "Couture",
    "Formal Gowns",
    "Tuxedos",
    "Statement Jewelry",
    "Crowns & Headpieces",
    "Dramatic Eveningwear",
    "Prom-Inspired Fashion",
  ],

  images: {
    logo: `${G}/gala-logo.webp`,
    heroA: `${G}/photo-14.jpg`, // gown lineup at the step & repeat
    heroB: `${G}/photo-13.jpg`, // guests in formal gowns
    heroC: `${G}/photo-16.jpg`, // celebration on the dance floor
    ballroom: `${G}/photo-04.jpg`,
    reception: `${G}/photo-01.jpg`,
    receptionFlowers: `${G}/photo-02.jpg`,
    checkin: `${G}/photo-03.jpg`,
    stepRepeat: `${G}/photo-05.jpg`,
    podium: `${G}/photo-06.jpg`,
    toast: `${G}/photo-07.jpg`,
    speech: `${G}/photo-08.jpg`,
    auctionCrowd: `${G}/photo-09.jpg`,
    paddleRaise: `${G}/photo-10.jpg`,
    paddles: `${G}/photo-11.jpg`,
    micMoment: `${G}/photo-12.jpg`,
    gownGroup: `${G}/photo-13.jpg`,
    gownLineup: `${G}/photo-14.jpg`,
    dancing: `${G}/photo-15.jpg`,
    danceFloor: `${G}/photo-16.jpg`,
    // mission & children imagery (textured-hair care, confidence, family)
    childBraids: "https://images.pexels.com/photos/14277035/pexels-photo-14277035.jpeg?auto=compress&cs=tinysrgb&w=1200",
    childSmile: "https://images.pexels.com/photos/14930866/pexels-photo-14930866.jpeg?auto=compress&cs=tinysrgb&w=1200",
    s4kHaircare: `${G}/s4k-haircare.jpg`, // stylist caring for a child's hair at the S4K salon
    s4kHairshow: `${G}/s4k-hairshow.jpg`, // S4K kids on stage at the annual hair show
    s4kFamily: `${G}/s4k-family.jpg`, // a Styles 4 Kidz family
    s4kSalon: `${G}/s4k-salon.jpg`, // the S4K salon, Oak Park
    // fashion mood (adult prom inspiration)
    tuxedo: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=1200&q=80",
    fashion: "https://images.unsplash.com/photo-1566174053879-31528523f8ae?auto=format&fit=crop&w=1200&q=80",
    gown: "https://images.pexels.com/photos/29479990/pexels-photo-29479990.jpeg?auto=compress&cs=tinysrgb&w=1200",
    // chicago & after dark
    chicago: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=2000&q=80",
    chicagoBean: "https://images.unsplash.com/photo-1494522855154-9297ac14b55f?auto=format&fit=crop&w=1200&q=80",
    dj: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1400&q=80",
    club: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=1400&q=80",
    sparkler: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1200&q=80",
  },
};

export const fmtUSD = (n) =>
  n === null || n === undefined ? "TBA" : "$" + n.toLocaleString("en-US");

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
